import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, Chip, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import { useState } from "react";
import { IPeopleListResponseDto } from "../../../shared/services/api/people/types";
import { globalBackgroundPeople, globalColorPeople, globalMaskDocument, globalTranslateStatusPeople, maskPhone } from "../../../shared/utils";
import { CopyableTypography } from "../../../shared/utils/CopyableTypography";
import { formatDateFnsRemoveTimezone } from "../../../shared/utils/format-date";
import { PeopleMenuModalType, PeopleMenuTable } from "../Menu/PeopleMenu";
import { ModalCreatePeople } from "../Modals/ModalCreatePeople";

interface TablePeopleProps {
	rows: IPeopleListResponseDto[];
	page: number;
	rowsPerPage: number;
	totalCount: number;
	onPageChange: (newPage: number) => void;
	onRowsPerPageChange: (newRowsPerPage: number) => void;
	onRefresh: () => void;
}

export const TablePeople = ({ rows, page, rowsPerPage, totalCount, onPageChange, onRowsPerPageChange, onRefresh }: TablePeopleProps) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [selectedRow, setSelectedRow] = useState<IPeopleListResponseDto | null>(null);
	const [modalType, setModalType] = useState<PeopleMenuModalType | null>(null);

	const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, row: IPeopleListResponseDto) => {
		setAnchorEl(event.currentTarget);
		setSelectedRow(row);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleOpenModal = (type: PeopleMenuModalType, row: IPeopleListResponseDto) => {
		setSelectedRow(row);
		setModalType(type);
	};

	const handleCloseModal = () => {
		setSelectedRow(null);
		setModalType(null);
	};

	return (
		<TableContainer component={Paper} sx={{ mt: 1, width: "96%", px: { xs: 1, sm: 3 }, py: { xs: 2, sm: 3 }, ml: 1, borderRadius: 2, overflow: "hidden" }}>
			<Table size="small">
				<TableHead>
					<TableRow sx={{ backgroundColor: "grey.100" }}>
						{["Data", "Pessoa", "Email", "Telefones", "Motivo", "Status", "Ações"].map((label, i) => (
							<TableCell key={i} align={i === 6 ? "right" : "left"}>
								<Typography variant="button">{label}</Typography>
							</TableCell>
						))}
					</TableRow>
				</TableHead>

				<TableBody>
					{rows.map((row) => (
						<TableRow key={row.id}>
							<TableCell>{formatDateFnsRemoveTimezone(row.createdAt)}</TableCell>

							<TableCell>
								<CopyableTypography fontWeight="bold" value={row.name} />
								<CopyableTypography
									value={globalMaskDocument(row.document)}
									variant="body2"
									fontWeight={400}
									sx={{ color: "text.secondary" }}
								/>
							</TableCell>

							<TableCell>
								<CopyableTypography value={row.email} fontWeight={400} />
							</TableCell>

							<TableCell>
								<CopyableTypography value={maskPhone(row.phone)} fontWeight={400} />
								<CopyableTypography value={maskPhone(row.mobilePhone)} fontWeight={400} />
							</TableCell>

							<TableCell>
								<CopyableTypography fontWeight="bold" value={row.reason} />
							</TableCell>

							<TableCell>
								<Chip
									size="medium"
									label={globalTranslateStatusPeople(row.status)}
									sx={{
										color: globalColorPeople(row.status),
										fontWeight: 500,
										background: globalBackgroundPeople(row.status),
										border: "0.5px solid #f1f1f1",
									}}
								/>
							</TableCell>

							<TableCell align="right">
								<IconButton onClick={(e) => handleMenuOpen(e, row)}>
									<MoreVertIcon />
								</IconButton>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>

			{/* Paginação */}
			<Box display="flex" justifyContent="flex-end" alignItems="center" mt={2} pr={2}>
				<TablePagination
					component="div"
					count={totalCount}
					page={page}
					rowsPerPage={rowsPerPage}
					onPageChange={(_, newPage) => onPageChange(newPage)}
					onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
					rowsPerPageOptions={[10, 25, 50]}
					labelRowsPerPage="Linhas por página:"
					labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count} registros`}
				/>
			</Box>

			{/* Menu de ações */}
            <PeopleMenuTable
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleMenuClose}
				selectedRow={selectedRow}
				onOpenModal={handleOpenModal}
			/>

            {modalType && selectedRow && (
                <ModalCreatePeople
                    open={Boolean(modalType)}
                    onClose={handleCloseModal}
                    selectedRow={selectedRow}
					onSuccess={onRefresh}
                />
            )}
		</TableContainer>
	);
};
